<template>
  <div v-if="localPresetsExists">
    <div class="pb-3 body-2">Manage your locally saved presets</div>
    <div class="container">
      <div
        :key="preset.name"
        v-for="preset in localPresets"
        :class="{
          'presets-box mr-2 caption white--text': true,
          [preset.color]: true
        }"
      >
        {{ preset.name }}
        <v-icon
          @click="deletePresetModal(preset.name)"
          style="cursor: pointer"
          class="white--text body-1"
          >mdi-close</v-icon
        >
      </div>
    </div>

    <v-dialog v-model="deletePresetModalOpen" max-width="600">
      <v-card class="mx-auto">
        <v-card-title>
          <div class="subheading">
            Are you sure you want to delete "{{ deletePresetName }}?"
          </div>
        </v-card-title>

        <v-card-text>
          The preset "{{ deletePresetName }}" will not be available once you
          reload this page.
        </v-card-text>

        <v-card-actions class="mt-4 ml-2">
          <v-btn
            class="px-3"
            color="theme-main-color accent-4 white--text"
            @click="deletePreset"
          >
            Yes, delete!
          </v-btn>
          <v-btn
            class="px-3"
            outlined
            color="secondary accent-4"
            @click="deletePresetModalOpen = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'Saved-preset-box',
  data: () => ({
    boxColors: [
      'green',
      'black',
      'indigo',
      'cyan',
      'teal',
      'orange',
      'secondary',
      'blue'
    ],
    deletePresetName: null,
    deletePresetModalOpen: false,
    localStoragePresets: null
  }),
  methods: {
    ...mapMutations(['setPresets']),
    deletePresetModal(preset) {
      this.deletePresetName = preset
      this.deletePresetModalOpen = true
    },
    deletePreset() {
      const preset = this.deletePresetName
      const localStoragePresets =
        localStorage.presets && JSON.parse(localStorage.getItem('presets'))
      if (!localStoragePresets) return null
      const newPresets = { ...localStoragePresets }
      delete newPresets[preset]
      localStorage.setItem('presets', JSON.stringify(newPresets))
      this.deletePresetModalOpen = false
      this.localStoragePresets =
        localStorage.presets && JSON.parse(localStorage.getItem('presets'))
      const newPresetsToStore = {
        ...this.allPresets
      }
      delete newPresetsToStore[preset]
      this.setPresets(newPresetsToStore)
    }
  },
  computed: {
    ...mapState({
      allPresets: ({ config }) => config.allPresets
    }),
    localPresetsExists() {
      const localStoragePresets =
        localStorage.presets && JSON.parse(localStorage.getItem('presets'))
      return localStoragePresets && Object.keys(localStoragePresets).length
    },
    localPresets() {
      const { localStoragePresets } = this
      const savedPresets = []
      for (const preset in localStoragePresets) {
        const presetObj = {
          name: preset,
          color:
            this.boxColors[
              Math.ceil(Math.random() * (this.boxColors.length - 1))
            ]
        }
        savedPresets.push(presetObj)
      }
      return savedPresets
    }
  },
  created() {
    this.localStoragePresets =
      localStorage.presets && JSON.parse(localStorage.getItem('presets'))
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.container {
  border: 1px solid grey;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  .presets-box {
    margin: 3px 0;
    display: block;
    padding: 5px 10px;
    border-radius: 5px;
    color: white;
  }
}
</style>
